<template>
  <div class="bind-api" data-automation="bindApi">
    <div class="x-flex-align x-margin-b">
      <ux-select
        v-model="formData.group"
        :clearable="false"
        :options="data"
        :props="{ label: 'name', value: 'id' }"
        :placeholder="$t('HT.rules.testApi.apiGroup')"
        @change="change"
      ></ux-select>
      <ux-select
        v-model="formData.env"
        :options="$opt.env2"
        :clearable="false"
        :placeholder="$t('HT.addAccessApi.evn.placeholder')"
        @change="change"
      ></ux-select>
    </div>
    <div class="transfer x-flex-align x-margin-28">
      <div class="left" :class="[flag ? 'left-toast' : 'left']">
        <p v-if="flag" style="color: red">{{ $t('HT.rules.bindApi.apiId') }}</p>
        <my-checkbox-group
          v-model="value"
          :list="apiList"
          value="id"
          label="name"
          valueSolt="env"
          @changeBox="changeBox"
        ></my-checkbox-group>
      </div>
      <div class="right">
        <p class="text_api">{{ $t('HT.bindFlowApi.text') }}:</p>
        <ul class="check-list">
          <li v-for="(item, index) in checkList">{{ item.name }}</li>
        </ul>
      </div>
    </div>
    <my-footer-btn spacing="80px" padding="10px" @close="close" @confirm="confirm"></my-footer-btn>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      // 分组
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      apiList: [], // api列表
      checkList: [], // 选择API
      formData: {
        group: '',
        env: '',
        page: 1,
        size: 10
      },
      value: [],
      props: {
        key: 'id',
        label: 'name'
      },
      flag: false
    };
  },
  watch: {
    checkList: {
      handler() {
        this.flag = false;
      }
    }
  },
  methods: {
    /**
     * 根据分组和环境筛选已上线的API
     *
     */
    change() {
      if (this.formData.env == '') return;
      this.getPublish(this.formData);
    },
    /**
     * 设置已经勾选的项
     * @param {Object} params 查询对象
     */
    setValue(env) {
      this.value.splice(0, this.value.length);
      for (let i = 0; i < this.checkList.length; i++) {
        let item = this.checkList[i];
        if (item.env == env) {
          this.$set(this.value, this.value.length, item.id + item.env);
        }
      }
    },
    /**
     * 查询已发布的API接口
     * @param {Object} params 查询对象
     */
    getPublish(params) {
      this.$uxLoading.show();
      this.$api.api.getPublish(params).then((res) => {
        if (res.code == 10000) {
          this.apiList = res.data;
          this.$nextTick(() => {
            this.setValue(this.formData.env);
          });
        }
      });
    },

    /**
     * 取消回调
     */
    close() {
      this.$uxModal.hide();
      this.$emit('close');
    },

    /**
     * 确认回调
     */
    confirm() {
      if (this.checkList.length === 0) {
        this.flag = true;
        // this.$uxModal.hide();
        return;
      }
      let res = [];
      for (let i = 0; i < this.checkList.length; i++) {
        res.push({
          api: this.checkList[i]['id'],
          env: this.checkList[i]['env']
        });
      }
      this.$emit('confirm', { apis: res });
    },
    /**
     * 选中Api   true为选中 false 为取消勾选
     * @param {Object} params 查询对象
     */
    changeBox(flag, val, item) {
      if (flag) {
        this.checkList.push(item);
      } else {
        this.delCheckList(item.id, this.formData.env);
      }
    },
    /**
     * 从已选列表中删除
     * @param {Object} params 查询对象
     */
    delCheckList(id, env) {
      for (let i = 0; i < this.checkList.length; i++) {
        let item = this.checkList[i];
        if (item.id == id && item.env == env) {
          this.checkList.splice(i, 1);
          break;
        }
      }
    }
  }
};
</script>

<style lang="scss">
.bind-api {
  .el-select {
    width: 230px;
    margin-right: 10px;
  }

  .transfer {
    .text_api {
      color: #cccccc;
    }
    > div {
      flex: 1;
      width: 200px;
      height: 300px;
      border: 1px solid #d7dde7;
      border-radius: 4px;
      padding: 10px;
      overflow: auto;
    }
    .left-toast {
      border: 1px solid red;
      margin-right: 10px;
    }
    .left {
      margin-right: 10px;
    }

    .check-list {
      display: flex;
      flex-direction: column;

      > li {
        margin: 2px 0;
        white-space: nowrap;
      }
    }
  }

  .el-checkbox-group {
    display: flex;
    flex-direction: column;

    .el-checkbox {
      margin: 2px 0;
    }
  }
}
</style>
